export default "__VITE_ASSET__BlGgxkpy__"